// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"bfbd338f","462":"08112b17"}[chunkId] + ".chunk.js";
};